import React, { useMemo } from "react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from "react-icons/fi";

const Pagination = ({
  currentPage,
  totalPages,
  rowsPerPage,
  totalItems,
  rowsPerPageOptions = [10, 25, 50, 100],
  onPageChange,
  onRowsPerPageChange,
  disabled = false,
}) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;
  const hasNoData = totalItems === 0;

  const getCurrentPageItemCount = () => {
    if (hasNoData) return 0;
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, totalItems);
    return endIndex - startIndex;
  };

  const currentPageItemCount = useMemo(() => {
    return getCurrentPageItemCount();
  }, [currentPage, rowsPerPage, totalItems]);

  const handlePageChange = (page) => {
    if (disabled || page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  const handleRowsPerPageChange = (event) => {
    if (disabled) return;
    const newRowsPerPage = parseInt(event.target.value);
    onRowsPerPageChange(newRowsPerPage);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e5e7eb',
      position: 'relative'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#6b7280' }}>
        <span style={{ fontFamily: 'Roboto, sans-serif' }}>
          {currentPageItemCount} of {totalItems} row(s) selected.
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '14px', color: '#6b7280', fontFamily: 'Roboto, sans-serif' }}>
            Rows per page
          </span>
          <select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            disabled={disabled || hasNoData}
            style={{
              padding: '8px',
              fontSize: '14px',
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '4px',
              color: '#111827',
              fontFamily: 'Roboto, sans-serif',
              opacity: disabled || hasNoData ? 0.5 : 1,
              cursor: disabled || hasNoData ? 'not-allowed' : 'pointer',
              outline: 'none'
            }}
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <div style={{ fontSize: '14px', color: '#6b7280', fontFamily: 'Roboto, sans-serif' }}>
          Page {currentPage} of {totalPages}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <button
            onClick={() => handlePageChange(1)}
            disabled={disabled || isFirstPage || hasNoData}
            style={{
              padding: '4px',
              borderRadius: '4px',
              opacity: disabled || isFirstPage || hasNoData ? 0.5 : 1,
              cursor: disabled || isFirstPage || hasNoData ? 'not-allowed' : 'pointer',
              backgroundColor: 'transparent',
              border: 'none',
              transition: 'background-color 0.2s'
            }}
            title="First page"
          >
            <FiChevronsLeft style={{ width: '16px', height: '16px', color: '#6b7280' }} />
          </button>

          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={disabled || isFirstPage || hasNoData}
            style={{
              padding: '4px',
              borderRadius: '4px',
              opacity: disabled || isFirstPage || hasNoData ? 0.5 : 1,
              cursor: disabled || isFirstPage || hasNoData ? 'not-allowed' : 'pointer',
              backgroundColor: 'transparent',
              border: 'none',
              transition: 'background-color 0.2s'
            }}
            title="Previous page"
          >
            <FiChevronLeft style={{ width: '16px', height: '16px', color: '#6b7280' }} />
          </button>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={disabled || isLastPage || hasNoData}
            style={{
              padding: '4px',
              borderRadius: '4px',
              opacity: disabled || isLastPage || hasNoData ? 0.5 : 1,
              cursor: disabled || isLastPage || hasNoData ? 'not-allowed' : 'pointer',
              backgroundColor: 'transparent',
              border: 'none',
              transition: 'background-color 0.2s'
            }}
            title="Next page"
          >
            <FiChevronRight style={{ width: '16px', height: '16px', color: '#6b7280' }} />
          </button>

          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={disabled || isLastPage || hasNoData}
            style={{
              padding: '4px',
              borderRadius: '4px',
              opacity: disabled || isLastPage || hasNoData ? 0.5 : 1,
              cursor: disabled || isLastPage || hasNoData ? 'not-allowed' : 'pointer',
              backgroundColor: 'transparent',
              border: 'none',
              transition: 'background-color 0.2s'
            }}
            title="Last page"
          >
            <FiChevronsRight style={{ width: '16px', height: '16px', color: '#6b7280' }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
